var render = function render(){var _vm=this,_c=_vm._self._c;return _c('appTemplate',[_c('router-view',{attrs:{"path":"$router.key"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }